import { modelForId, visitSpecs, COMPONENT_TYPE } from "./plano";

/**
 * Renvoie toutes les teintes du planogramme
 * @param config
 * @returns {[]}
 */
export function findAllShades(config) {
    const res = [];
    visitSpecs(config.content.paper, spec => {
        const model = modelForId(config, spec.model);
        if (model && model.type === COMPONENT_TYPE.module && spec.shadeByGroup) {
            for (let shade of Object.entries(spec.shadeByGroup)) {
                res.push(shade[1]);
            }
        }
    });
    return res;
}



// WEBPACK FOOTER //
// ./src/plano/utils/plano-stats.js